module.exports = "/_next/static/images/HCGO_Website-Banner-51245889a06041cdc1ce3f58a8569183.jpg";